module.exports = ":host .st__container li {\n  margin-bottom: 0.5em; }\n\n:host .st__container ul {\n  margin-bottom: 2em; }\n\n:host .st__container .st-button__container {\n  display: flex;\n  justify-content: flex-end; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-components/shipment-types/shipment-types.presentation.scss
// module id = +hW6
// module chunks = 12